import { createTheme } from '@mui/material/styles'
import { KermitCommonColors, KermitShape, CustomTheme } from './theme.types'
import createPalette from '@mui/material/styles/createPalette'
import { green, purple } from '@mui/material/colors'
import { ibmPlexSansCssVariable } from '@/styles/fonts'

const commonColors: KermitCommonColors = {
  white: '#FFFFFF',
  white1: '#F6F7F8',
  red: '#B43030',
  red1: '#F8F0F0',
  green: '#00A878',
  green1: '#3C6E71',
  green2: '#EAF8F9',
  green3: '#01A978',
  black: '#27213C',
  yellow: '#FFBF00',
  yellow1: '#F8E3A6',
  yellow2: '#D39E00',
  grey: '#EFF1F3',
  grey1: '#CFCCD6',
  grey2: '#868196',
  grey3: '#988FA8',
  grey4: '#5F5F5F',
  blue1: '#153eab',
}

const shape: KermitShape = {
  borderRadius: {
    primary: 2,
    secondary: 6,
  },
}

const customTheme: CustomTheme = {
  custom: {
    colors: {
      common: commonColors,
    },
    shape,
  },
}

const fontFamily = `var(${ibmPlexSansCssVariable}), "Helvetica", "Arial", sans-serif`

export const theme = createTheme({
  // https://mui.com/material-ui/migration/v5-component-changes/#breakpoint-sizes
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: createPalette({
    primary: {
      main: purple[500],
    },
    secondary: {
      main: green[500],
    },
    success: {
      main: commonColors.green as string,
    },
  }),
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          paddingRight: '0 !important',
        },
      },
    },
  },
  typography: {
    fontFamily,
    h2: {
      fontFamily,
      fontWeight: 600,
      fontSize: '24px',
      lineHeight: '32px',
      letterSpacing: 'normal',
    },
    h3: {
      fontFamily,
      fontWeight: 600,
      fontSize: '18px',
      lineHeight: '23px',
      letterSpacing: 'normal',
    },
    body1: {
      fontFamily,
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '21px',
      letterSpacing: 'normal',
    },
    body2: {
      fontFamily,
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: 'normal',
      '&.Mui-disabled': {
        color: commonColors.grey1,
      },
    },
    caption: {
      fontFamily,
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: 'normal',
      color: commonColors.black,
      '&.Mui-disabled': {
        color: commonColors.grey1,
      },
    },
    overline: {
      fontFamily,
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: 'normal',
    },
  },
  shape: {
    borderRadius: 2,
  },
  zIndex: {
    modal: 2147483602,
  },
  ...customTheme,
})
